<template>
  <div class="account-settings">
    <h1 class="settings-title">
      Change Password
    </h1>
    <div class="settings-form">
      <h2 class="settings-subtitle">
        Add new password
      </h2>
      <div>
        <b-form-group>
          <label
            for="password"
            class="settings-label">
            Current Password
          </label>
          <b-input
            id="password"
            v-model="password"
            v-validate="'required'"
            name="password"
            data-vv-as="Current password"
            type="password"
            placeholder="Password"
            autofocus/>
        </b-form-group>
        <span
          v-if="errors.has('password')"
          class="validation-error">{{ errors.first('password') }}</span>
        <span
          v-if="validationErrors.password"
          class="validation-error">{{ validationErrors.password }}</span>
      </div>
      <div>
        <b-form-group>
          <label
            for="new-password"
            class="settings-label">
            New Password
          </label>
          <b-input
            id="new-password"
            v-model="newPassword"
            v-validate="'required'"
            name="new_password"
            data-vv-as="New Password"
            type="password"
            placeholder="New Password"/>
        </b-form-group>
        <span
          v-if="errors.has('new_password')"
          class="validation-error">{{ errors.first('new_password') }}</span>
        <span
          v-if="validationErrors.newPassword"
          class="validation-error">{{ validationErrors.newPassword }}</span>
      </div>
    </div>
    <div
      v-if="passwordUpdated"
      class="account-settings__success">
      Password has been successfully updated.
    </div>
    <div
      v-if="errorMessage"
      class="account-settings__error">
      {{ errorMessage }}
    </div>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="account-settings__submit btn-round"
      @click="savePassword">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </div>
</template>

<script>
import setValidationErrors from '@/helpers/validationErrors';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PasswordSettings',
  data() {
    return {
      password: '',
      newPassword: '',
      errorMessage: '',
      saving: false,
      passwordUpdated: false,
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'user/apiError',
      successPasswordUpdate: 'user/successPasswordUpdate',
    }),
  },
  watch: {
    successPasswordUpdate(success) {
      if (success) {
        this.saving = false;
        this.passwordUpdated = true;
        setTimeout(() => {
          this.passwordUpdated = false;
        }, 3000);
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else if (error.status === 401) {
        this.errorMessage = 'Authentication failed. Wrong Password.';
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      updateUserPassword: 'user/updateUserPassword',
    }),
    savePassword() {
      this.errorMessage = '';
      this.validationErrors = {};
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.saving = true;
          const payload = {
            password: this.password,
            new_password: this.newPassword,
          };
          this.updateUserPassword(payload);
        }
      });
    },
  },
};
</script>
